module.exports = __webpack_public_path__ + "static/media/muy-mala-hover.4c353fa5.svg";